import styles from './Resume.module.css';
import { useEffect, useRef } from 'react';

// --- DATI ---
const educationData = [
    {
        year: '2017',
        title: 'Diploma di Perito Agrario',
        description: 'Conseguito diploma di maturità con specializzazione in ambito agrario.'
    },
    {
        year: '2023',
        title: 'Corso di Formazione Office',
        description: 'Studiato e completato corsi online su Word ed Excel, livelli base e avanzato.'
    },
    {
        year: '2024',
        title: 'Sviluppo Web Front-End',
        description: 'Appassionato allo sviluppo web, ho iniziato a studiare online per acquisire competenze in HTML, CSS e JavaScript. Con i primi progetti online personali e per alcune aziende, ho arricchito le mie conoscenze.'
    },
    {
        year: '2024',
        title: 'Excel VBA',
        description: 'Approfondito le conoscenze di Excel attraverso lo studio del linguaggio di programmazione VBA.'
    },
    {
        year: '2025',
        title: 'Sviluppo Web Back-End',
        description: 'Per ampliare le mie competenze, ho iniziato lo studio del back-end, in particolare MySQL, PHP e Laravel.'
    }
];

const experienceData = [
    {
        year: '2018 - Presente',
        title: 'Responsabile Logistica',
        description: `Sono entrato in azienda partendo dalla produzione. Grazie all'impegno e alla voglia di imparare, sono cresciuto fino a diventare responsabile della logistica. Ora sto ampliando le mie competenze occupandomi anche dei primi aspetti di contabilità.`}
];


export default function Resume () {
    const itemsRef = useRef([]);

    useEffect(() => {
        // 1. Salva il riferimento corrente in una variabile locale
        const currentItems = itemsRef.current;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add(styles.show);
                }
            });
        }, { threshold: 0.2 });

        //  variabile locale per osservare gli elementi
        currentItems.forEach(item => {
            if (item) observer.observe(item);
        });

        // 2. Usa la STESSA variabile locale nella funzione di pulizia
        // Questo risolve il warning di ESLint.
        return () => {
            currentItems.forEach(item => {
                if (item) observer.unobserve(item);
            });
        };
    }, []);

    return (
        <section className={styles.resume}>
            <h2>PERCORSO</h2>
            <div className={styles.timeline}>

                {/* --- COLONNA EDUCATION --- */}
                <div className={styles.timelineColumn}>
                    <h3 className={styles.columnTitle}><i className='bx bxs-graduation' aria-hidden="true"></i> Educazione</h3>
                    {educationData.map((item, index) => (
                        <div className={styles.timelineItem} key={`edu-${index}`} ref={el => itemsRef.current[index] = el}>
                            <div className={styles.timelineIcon}></div>
                            <div className={styles.timelineContent}>
                                <span className={styles.timelineYear}>{item.year}</span>
                                <h4>{item.title}</h4>
                                <p>{item.description}</p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* --- COLONNA EXPERIENCE --- */}
                <div className={styles.timelineColumn}>
                    <h3 className={styles.columnTitle}><i className='bx bx-briefcase' aria-hidden="true"></i> Esperienze professionali</h3>
                    {experienceData.map((item, index) => (
                        <div className={styles.timelineItem} key={`exp-${index}`} ref={el => itemsRef.current[educationData.length + index] = el}>
                            <div className={styles.timelineIcon}></div>
                            <div className={styles.timelineContent}>
                                <span className={styles.timelineYear}>{item.year}</span>
                                <h4>{item.title}</h4>
                                <p>{item.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
